import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { TableContainer, Table,  TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { formatISO } from 'date-fns';

const styleSheet = theme => ({
    paper: {
      // [theme.breakpoints.up('xs')]: {
        padding: theme.spacing(1),
      // },
      // [theme.breakpoints.up('sm')]: {
      //   padding: theme.spacing(2),
      // },
      // [theme.breakpoints.up('md')]: {
      //   padding: theme.spacing(3),
      // },
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCell: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadCellWidth100: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
      width: 100
    },
    tblHeadRow2: {
      height: 24,
    },
    tblHeadCell2: {
      textAlign: 'center',
      verticalAlign: 'top',
      //borderBottom: 0,
    },
    tblHeadRow3: {
      height: 32,
    },
    tblCellWidth100: {
      width: 100,
    },
    appnameitem: {
      marginLeft: 8,
    },
    [theme.breakpoints.up('sm')]: {
      tblCellDateCol: {
        paddingLeft: 10,
        paddingRight: 10,
        width: 50,
      },
      tblCellAppCol: {
        paddingLeft: 10,
        paddingRight: 10,
        minWidth: 200,
        width: 250,
      }
    },
    [theme.breakpoints.up('xs')]: {
      tblCellDateCol: {

      },
      tblCellAppCol: {

      }
    },

});

class AuditsList extends React.Component {
  goTo(url) {
    if (url == null)
      return;
          
    this.props.history.push(`/${url}`);
   }        

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.al.nodes;

    return (
    <div className={classes.paper}>
    <TableContainer>
      <Table>
        <TableHead className={classes.tblHead}>
          <TableRow className={classes.tblHeadRow}>
            <TableCell className={classes.tblHeadCell}>Timestamp</TableCell>
            <TableCell className={classes.tblHeadCell}>Account</TableCell>
            <TableCell className={classes.tblHeadCell}>Severity</TableCell>
            <TableCell className={classes.tblHeadCell}>Audit Type</TableCell>
            <TableCell colSpan={3} className={classes.tblHeadCell}>Audit Detail</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { thenodes.map(n => {
            let theUrl=null;
            if (n.accountType === 1) {
                theUrl = "vendor?accountId=" + n.accountId;
            } else if (n.accountType === 3) {
                theUrl = "reseller?accountId=" + n.accountId;
            } else if (n.accountType === 4) {
                theUrl = "customer?accountId=" + n.accountId;
            }
            
            //audit time is unzoned, need to declare it as utc.
            let atime = formatISO(new Date(n.auditTime+'Z'));

            let theSeverity = 'Unidentified';
            switch(n.severity) {
              case 0:
                theSeverity = 'Critical';
                break;
              case 1:
                theSeverity = 'Error';
                break;
              case 2:
                theSeverity = 'Warning';
                break;
              case 3:
                theSeverity = 'Info';
                break;                      
              default:
                theSeverity = 'Info';
                break;                      
              }

            return (
              <TableRow key={n.auditId} onClick={() => {this.goTo(theUrl);}}>
                <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellDateCol}>{atime}</TableCell>
                <TableCell>{n.accountName}</TableCell>
                <TableCell>{theSeverity}</TableCell>
                <TableCell>{n.auditType}</TableCell>
                <TableCell colSpan={3}>{n.auditDetail}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
    );
  } // end render()
}

AuditsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

/*
export default createFragmentContainer(AuditsList, graphql`
  fragment AuditsList_al on AuditEntriesConnection {
    nodes {
      auditId
      accountId
      accountName
      accountType
      userId
      auditType
      auditDetail
      auditTime
    }
  }
`);
*/

export default createFragmentContainer(withStyles(styleSheet)(AuditsList), { al: graphql`
  fragment AuditsList_al on AuditEntriesConnection {
    nodes {
      auditId
      accountId
      accountName
      accountType
      userId
      severity
      auditType
      auditDetail
      auditTime
    }
  }
` });
